"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Entity = void 0;
/**
 * This client is generic and non specific to a certain entity id.
 * Only generic calls without id context like `create()`, `list()` etc are available.
 * See the non generic counterpart client for context calls like `update()`, `delete()` if you want to operate on a specific instance.
 */
class Entity {
    constructor(parentEntity, debug = false) {
        this.parentEntity = parentEntity;
        this.debug = debug;
    }
    /**
     * Returns a reference to the top most client containing configs that might be useful for child clients
     * @returns
     */
    getPlatformClient() {
        return this.parentEntity.getPlatformClient();
    }
    /** Returns a reference to the central Http Client propagated from the parent entity clients */
    getHttpClient() {
        return this.parentEntity.getHttpClient();
    }
    /** Returns a reference from the parent entity clients, propagated from other entities.
     * **This method should be overridden if the current entity demands another header composition** */
    getHeaders() {
        return this.parentEntity.getHeaders();
    }
    _log(message) {
        if (this.debug)
            console.log(message);
    }
}
exports.Entity = Entity;
